import React from 'react';
import { Send } from 'lucide-react';
import { categories } from '../../data/mock';

const sessionTypes = categories.filter(c => c.id !== 'all');
const PACKAGES = [
  { id: 'classic', label: 'Classic — 1,000 AED (20 edited photos)' },
  { id: 'signature', label: 'Signature — 1,400 AED (30 edited photos)' }
];
const today = new Date().toISOString().split('T')[0];

const Field = ({ label, children }) => (
  <div className="form-group">
    <label className="form-label">{label}</label>
    {children}
  </div>
);

export const ContactForm = ({ formData, isSubmitting, onChange, onSubmit }) => (
  <form onSubmit={onSubmit} className="contact-form" data-testid="contact-form">
    <Field label="Your Name *">
      <input type="text" name="name" value={formData.name} onChange={onChange} required
        className="form-input" placeholder="Enter your full name" data-testid="contact-name-input" />
    </Field>
    <Field label="Email Address *">
      <input type="email" name="email" value={formData.email} onChange={onChange} required
        className="form-input" placeholder="your@email.com" data-testid="contact-email-input" />
    </Field>
    <Field label="Phone Number">
      <input type="tel" name="phone" value={formData.phone} onChange={onChange}
        className="form-input" placeholder="+971 XX XXX XXXX" data-testid="contact-phone-input" />
    </Field>
    <Field label="Session Type *">
      <select name="sessionType" value={formData.sessionType} onChange={onChange} required
        className="form-select" data-testid="contact-session-select">
        <option value="">Select a session type</option>
        {sessionTypes.map(c => (
          <option key={c.id} value={c.id}>{c.name}</option>
        ))}
      </select>
    </Field>
    <Field label="Package *">
      <select name="packageType" value={formData.packageType} onChange={onChange} required
        className="form-select" data-testid="contact-package-select">
        <option value="">Select a package</option>
        {PACKAGES.map(p => (
          <option key={p.id} value={p.id}>{p.label}</option>
        ))}
      </select>
    </Field>
    <Field label="Preferred Date">
      <input type="date" name="preferredDate" value={formData.preferredDate} onChange={onChange}
        className="form-input" min={today} data-testid="contact-date-input" />
    </Field>
    <Field label="Message">
      <textarea name="message" value={formData.message} onChange={onChange}
        className="form-textarea" placeholder="Tell me about your vision for the photoshoot..."
        data-testid="contact-message-input" />
    </Field>
    <button type="submit" disabled={isSubmitting}
      className="btn-submit flex items-center justify-center gap-2" data-testid="contact-submit-btn">
      {isSubmitting
        ? <><div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />Sending...</>
        : <><Send className="w-4 h-4" />Send Message</>}
    </button>
  </form>
);
